import { render, staticRenderFns } from "./ReactionMenu.vue?vue&type=template&id=fa8c6bbc&scoped=true"
import script from "./ReactionMenu.vue?vue&type=script&lang=js"
export * from "./ReactionMenu.vue?vue&type=script&lang=js"
import style0 from "./ReactionMenu.vue?vue&type=style&index=0&id=fa8c6bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8c6bbc",
  null
  
)

export default component.exports